// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"6d77eff8","453":"ca2760fc","455":"f9d1dca9"}[chunkId] + ".chunk.js";
};